export default __webpack_public_path__ + "static/minskEnergo-7ccf78570a90e10282383f98888c6e3e.png";